import { useTranslation } from 'react-i18next'
import IconLink from '@/shared/icons/NewDesign/IconLink'
import IconSmartphone from '@/shared/icons/NewDesign/IconSmartphone'
import ChoiceCard from '../ChoiceCard/ChoiceCard'
import { JOURNEY_COPY } from '../fidelityJourney'
import type { ConnectionChoiceProps } from '../types'
import { StyledChoices, StyledKicker } from '../styled-components'

const ConnectionChoice = ({ hidden, app, email }: ConnectionChoiceProps) => {
  const { t } = useTranslation()

  if (hidden) {
    return null
  }

  return (
    <>
      <StyledKicker>{t(`${JOURNEY_COPY}.connection.question`)}</StyledKicker>
      <StyledChoices role='group' aria-label={t(`${JOURNEY_COPY}.connection.question`)}>
        <ChoiceCard
          icon={<IconSmartphone />}
          title={t(`${JOURNEY_COPY}.choices.app.title`)}
          description={t(`${JOURNEY_COPY}.choices.app.description`)}
          selected={app.selected}
          onSelect={app.onSelect}
        />
        <ChoiceCard
          icon={<IconLink size={16} />}
          title={t(`${JOURNEY_COPY}.choices.email.title`)}
          description={t(`${JOURNEY_COPY}.choices.email.description`)}
          selected={email.selected}
          onSelect={email.onSelect}
        />
      </StyledChoices>
    </>
  )
}

export default ConnectionChoice
